import axios from "axios";

import { LayoutVariant } from "scmp-app/pages/home/styles";

interface HomepageCustomWidgetsConfig {
  thingsToDoPromotedByPlus: string;
}

export const getHomePageLayoutVariant = async (): Promise<LayoutVariant> => {
  try {
    const resp = await axios.get<HomepageCustomWidgetsConfig>(
      "https://assets-v2.i-scmp.com/data/homepage-custom-widgets.json", // Direct use the production's one because cron job run in production and does not run in staging
      {
        timeout: 1000,
      },
    );

    return resp?.data?.thingsToDoPromotedByPlus === "on"
      ? LayoutVariant.ThingsToDoPromotedByPlus
      : LayoutVariant.Default;
  } catch (error) {
    console.warn("Failed to fetch homepage layout variant, using default:", error);
    return LayoutVariant.Default;
  }
};
